import axios from "axios";

export const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_URL,
  headers: { "Content-Type": "application/json" },
});

// Attach token from localStorage to every request.
api.interceptors.request.use((config) => {
  const token = typeof window !== "undefined" ? localStorage.getItem("ggl_token") : null;
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Auto-logout on 401 from authed endpoints.
api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401 && typeof window !== "undefined") {
      const url = err?.config?.url || "";
      if (!url.endsWith("/auth/login")) {
        localStorage.removeItem("ggl_token");
        if (window.location.pathname.startsWith("/admin/dashboard")) {
          window.location.href = "/admin";
        }
      }
    }
    return Promise.reject(err);
  }
);

export function formatError(detail, fallback = "Something went wrong.") {
  if (detail == null) return fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
